"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiAvatar = void 0;
var colors_1 = require("../colors");
exports.MuiAvatar = {
    styleOverrides: {
        root: { fontSize: 20 },
        colorDefault: {
            backgroundColor: colors_1.tannerGray['600'],
        },
    },
};
//# sourceMappingURL=MuiAvatar.js.map